import {Component, ElementRef, Injector, Input, ViewChild} from '@angular/core';
import {ExcFileItem} from '../models/ExcFileItem';
import {ExcFormControl} from 'exc-controls';

/**
 * A form control element that manages file uploads. All uploads are converted into a ExcFileItem.
 * It implements this component the ControlValueAccessor interface.
 * Ta add an required validation, use the custom validator: ExcUploadRequired.
 */
@Component({
  selector: 'lib-exc-file-input',
  templateUrl: 'exc-file-input.component.html'
})
export class ExcFileInputComponent extends ExcFormControl {

  @Input() label: string;
  @Input() placeholder: string;
  @Input() buttonText: string;
  @ViewChild('inputFileElement') inputFileElement: ElementRef<HTMLInputElement>;

  /**
   * All files as ExcFileItems that were uploaded
   */
  private _files: ExcFileItem[] = [];
  get files(): ExcFileItem[] {
    return this._files;
  }

  set files(files: ExcFileItem[]) {
    this._files = files;
  }

  constructor(public injector: Injector) {
    super(injector);
  }

  writeValue(value: ExcFileItem[]): void {
    this._files = value;
  }

  showSelectDialog() {
    this.inputFileElement.nativeElement.click();
  }

  onFileChange() {
    this.processFileList(this.inputFileElement.nativeElement.files)
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    if (!this.disabled) {
      this.processFileList(event.dataTransfer.files)
    }
  }

  onDragOver(event: DragEvent) {
    // this is necessary to enable drag and drop mechanism
    event.preventDefault();
  }

  /**
   * Converts all files that were selected from file input or dragged from operating system to ExcFile objects
   * @param fileList - a list of files that should be processed
   */
  private processFileList(fileList: FileList) {
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i];
      const excFile = ExcFileItem.fromFile(file);
      excFile.afterLoading.subscribe(() => this.propagateChange(this.files));
      this.files.push(excFile);
    }
  }

  /**
   * Removes a file from file array
   * @param file - the file that has to be removed
   */
  removeFile(file: ExcFileItem) {
    const index = this.files.findIndex(item => item === file);
    this.files.splice(index, 1);
    this.propagateChange(this.files);
  }

  onBlur() {
    this.propagateTouch();
  }
}
